export const REPORT_PROFILE_URL =
  'https://www.paypal.com/us/smarthelp/contact-us/aupviolation'
